<script>

import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import ScheduledSheet from '../../components/operative-plan/ScheduledSheet.vue';
import EtaSheet from '../../components/operative-plan/EtaSheet.vue';
import DailyPlanningSheet from '../../components/operative-plan/DailyPlanningSheet.vue';
import SchedulingImplementationAttachments from '@/components/operative-plan/SchedulingImplementationAttachments.vue';


export default{
    components: {
        TabView, TabPanel, 
        ScheduledSheet, EtaSheet, DailyPlanningSheet, SchedulingImplementationAttachments
    },
    mounted(){
        this.$store.dispatch('security/setNavbarTitle', 'operativePlan.tracking_page_title');
    },
    created() {
        if (localStorage.getItem('colorScheme') === 'dark') {
            this.darkTheme = true;
        }
    },
    data(){
        return{
            darkTheme: false,
            schedulingImplementationAttachmentsVisible: false,
            schedulingImplementationAttachmentsId: null
        }
    },
    methods: {
        onTabChange(event){
            switch(event.index){
                case 0:
                    this.$refs.scheduledSheet.load(true);
                    break;
                case 1:
                    this.$refs.etaSheet.load(true);
                    break;
                case 2:
                    this.$refs.dailyPlanningSheet.load(true);
                    break;
            }
        },
        onPlantChange(a){
            this.$refs.scheduledSheet.setPlant(a);
            this.$refs.etaSheet.setPlant(a);
            this.$refs.dailyPlanningSheet.setPlant(a);
        },
        showSchedulingAttachmentsDialog(record){
            console.log(record)
            this.schedulingImplementationAttachmentsId = record.idMovementInstructionLot;
            this.schedulingImplementationAttachmentsVisible = true;
        }
    },
    computed: {
        uiPermissions(){
            return this.$store.getters['security/uiPermissions'];
        },
    }
}
</script>

<template>
    <main>
        <Dialog v-model:visible="schedulingImplementationAttachmentsVisible" modal :style="{ width: '85vw'}">
            <SchedulingImplementationAttachments :id="schedulingImplementationAttachmentsId" />
        </Dialog>

        <TabView @tab-change="onTabChange">
            <TabPanel :header="$t('operativePlan.scheduled')" v-if="uiPermissions('OperativePlan.ScheduledSheet').isEnabled">
                <ScheduledSheet ref="scheduledSheet" @on-plant-changed="onPlantChange" :class="darkTheme ? 'dark' : 'light'" @showSchedulingAttachmentsDialog="showSchedulingAttachmentsDialog"/>
            </TabPanel>
            <TabPanel :header="$t('operativePlan.eta')" v-if="uiPermissions('OperativePlan.EtaSheet').isEnabled">
                <EtaSheet ref="etaSheet" @on-plant-changed="onPlantChange" :class="darkTheme ? 'dark' : 'light'" @showSchedulingAttachmentsDialog="showSchedulingAttachmentsDialog"/>
            </TabPanel>
            <TabPanel :header="$t('operativePlan.dailyplanning')" v-if="uiPermissions('OperativePlan.DailyPlanSheet').isEnabled">
                <DailyPlanningSheet ref="dailyPlanningSheet" @on-plant-changed="onPlantChange" :class="darkTheme ? 'dark' : 'light'" @showSchedulingAttachmentsDialog="showSchedulingAttachmentsDialog"/>
            </TabPanel>
        </TabView>
    </main>
</template>

<style>

.dark .p-datatable .p-datatable-tbody > tr:focus {
    background-color: dimgray;
}

.light .p-datatable .p-datatable-tbody > tr:focus {
    background-color: lightgray;
}

</style>